export default {
  automotive: {
    sales: 'Sale',
    info_verb: {
      sales: 'purchased a vehicle',
      leads: 'submitted a lead',
    },
    description: {
      sales: `
            This dashboard presents <strong>verified sales</strong> data, tracking
            customers who
            <strong>
              purchased a car after being exposed to one of your advertisements
            </strong>
            . It highlights the correlation between ad exposure and subsequent vehicle
            purchases, providing insights into the <strong>effectiveness</strong> of
            advertising campaigns. The key metric on this report is the
            <strong>user's path to sales</strong>, which includes the impressions the user
            saw and interacted with before purchasing the vehicle.
          `,
      leads: `
            This dashboard presents <strong>verified leads</strong> data, tracking
            customers who
            <strong>
              submitted a lead after being exposed to one of your advertisements
            </strong>
            . It highlights the correlation between ad exposure and subsequent vehicle
            leads, providing insights into the <strong>effectiveness</strong> of
            advertising campaigns. The key metric on this report is the
            <strong>user's path</strong>, which includes the impressions the user
            saw and interacted with before submitting the lead.
          `,
    },
    leads: 'Lead',
    sale_event: 'Vehicle Sold',
  },
  //   For Unlock
  retail: {
    sales: 'Funded User',
    info_verb: {
      sales: 'funded an account',
      leads: 'created an account',
    },
    description: {
      sales: `
      This dashboard presents <strong>verified funded users</strong> data, tracking
      customers who
      <strong>
        deposited funds after being exposed to one of your advertisements
      </strong>
      . It highlights the correlation between ad exposure and subsequent funding, providing insights into the <strong>effectiveness</strong> of
      advertising campaigns. The key metric on this report is the
      <strong>user's journey</strong>, which includes the impressions the user
      saw and interacted with before depositing funds.
    `,
      leads: `
    This dashboard presents <strong>verified account creates</strong> data, tracking
    customers who
    <strong>
      created an account after being exposed to one of your advertisements
    </strong>
    . It highlights the correlation between ad exposure and subsequent account creations, providing insights into the <strong>effectiveness</strong> of
    advertising campaigns. The key metric on this report is the
    <strong>user's journey</strong>, which includes the impressions the user
    saw and interacted with before creating an account.
  `,
    },
    leads: 'Account Create',
    sale_event: 'User Funded',
  },
}
